export const emailSettings = {
  digests: {
    title: 'Digests',
    options: [
      {
        name: 'Daily',
        description: 'Subscribe to our Daily Digest to receive links to all research published in the last 24 hours that meet the criteria set by your preferences. Available for CreditSights, Covenant Review, and LevFin Insights content.',
        tagId: 'subscribable/fcidailydigest',
      },
      {
        name: 'Weekly',
        description:
          'Subscribe to our Weekly Digest to receive links to all research published in the last week (Friday through Thursday) that meet the criteria set by your preferences. Available for CreditSights, Covenant Review, and LevFin Insights content.',
        tagId: 'subscribable/fciweeklydigest',
      },
    ],
    sources: { research: true, news: true, covenants: true },
    timezones: [
      { text: 'New York', value: 'US Eastern Standard Time' },
      { text: 'London', value: 'GMT Standard Time' },
      { text: 'Singapore', value: 'Singapore Standard Time' },
    ],
  },
  morningComment: {
    title: 'Morning Comment',
    description: 'The CreditSights Morning Comment provides a curated summary of select research notes published over the previous 24 hours. Available for both the US and European markets, and sent at 6am (London / New York).',
    options: [
      {
        name: 'Americas',
        tagId: 'subscribable/us_morning_summary',
      },
      {
        name: 'Europe',
        tagId: 'subscribable/eu_morning_summary',
      },
    ],
    sources: { research: true, news: false, covenants: false },
  },
  weeklyReader: {
    title: 'Weekly Reader',
    description: 'Our weekly summaries list all research published in a specific region, for a specific market. Emails are sent on Fridays (New York / London) and Mondays (Singapore).',
    options: [
      {
        name: 'Americas',
        tagId: 'subscribable/weekend_reader_na',
      },
      {
        name: 'Europe',
        tagId: 'subscribable/weekend_reader_eu',
      },
      {
        name: 'Asia-Pacific',
        tagId: 'subscribable/weekend_reader_ap',
      },
    ],
    sources: { research: true, news: false, covenants: false },
  },
  summaries: {
    title: 'Summaries',
    options: [
      {
        name: 'Asia-Pacific Summary',
        description: 'Receive daily commentary on the Asian markets, and links to research from the region at 6am (Singapore).',
        tagId: 'subscribable/asia_pacific_summary',
      },
      {
        name: 'Europe High Yield Summary',
        description: 'Receive a daily email with links to all EU HY focused research at 6am (London).',
        tagId: 'subscribable/eu_high_yield_summary',
      },
      {
        name: 'US High Yield Summary',
        description: 'Receive a daily email with links to all US HY focused research at 6am (New York).',
        tagId: 'subscribable/na_high_yield_summary',
      },
      {
        name: 'New Issue Summary',
        description: 'Receive a daily email with links to our global New Issue research at 5pm (New York).',
        tagId: 'subscribable/new_issue_summary',
      },
    ],
    sources: { research: true, news: false, covenants: false },
  },
};
